
import { defineComponent, ref } from 'vue';
import nuevoUser from '@/pages/registro/registroUser.vue'

export default defineComponent({
  components:{registroUser:nuevoUser},

  setup(){
  const vistaComponente = ref('unserNuevo')
    return{vistaComponente}
  }
})

